import { render, staticRenderFns } from "./MessagesModal.vue?vue&type=template&id=e7d4324a&"
import script from "./MessagesModal.vue?vue&type=script&lang=js&"
export * from "./MessagesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports